
import { useState, useEffect, useRef } from 'react';
import { fetchCoastalSpots } from '../services/overpassService';
import { CampingSpot, MapBounds } from '../types';
import { boundsOverlapRatio } from '../utils/boundsUtils';

export const useCoastalSpots = (
  active: boolean,
  zoom: number,
  currentViewBounds: MapBounds | null,
  onNewSpots: (spots: CampingSpot[]) => void
) => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(false);
  const lastFetchedBoundsRef = useRef<MapBounds | null>(null);

  useEffect(() => {
    if (!active || zoom < 9 || !currentViewBounds) {
      setIsLoading(false);
      if (!active) { setError(false); lastFetchedBoundsRef.current = null; }
      return;
    }

    if (lastFetchedBoundsRef.current && boundsOverlapRatio(lastFetchedBoundsRef.current, currentViewBounds) > 0.7) {
      return;
    }

    const fetchMaritime = async () => {
      setIsLoading(true);
      try {
        const spots = await fetchCoastalSpots(currentViewBounds);
        if (spots.length > 0) {
          onNewSpots(spots);
        }
        setError(false);
        lastFetchedBoundsRef.current = currentViewBounds;
      } catch (e) {
        console.error("Failed to fetch coastal spots hook", e);
        setError(true);
      } finally {
        setIsLoading(false);
      }
    };

    const timer = setTimeout(fetchMaritime, 1200);
    return () => clearTimeout(timer);
  }, [currentViewBounds, active, zoom]);

  return { isLoading, error };
};
